module.exports = __webpack_public_path__ + "static/computer-5a36b72b9c21c6abf5446841420a6ca5.svg";